import * as React from "react";
import { forwardRef, memo } from "react";
const SvgOval = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 23, height: 24, viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M14 8.00781C14 11.3215 11.3137 14.0078 8 14.0078C4.68629 14.0078 2 11.3215 2 8.00781C2 4.6941 4.68629 2.00781 8 2.00781C11.3137 2.00781 14 4.6941 14 8.00781Z", fill: "white", stroke: "#525A68", strokeWidth: 4 }));
const ForwardRef = forwardRef(SvgOval);
const Memo = memo(ForwardRef);
export default Memo;
